import { defineComponent as _defineComponent } from 'vue'
import { computed, getCurrentInstance, watch } from 'vue'

import Message from '@/client/components/_atoms/Message.vue'
import { TrackingService } from '@/client/services'

import { useInstagramInstantwinPretestStore } from '../../hooks/instagramInstantwinPretestStore'
import { useInstagramDmTestCodeExpiry } from '../../hooks/useInstagramDmTestCodeExpiry'
import { getInstagramDmTestCodePanelState, isInstagramDmTestDisabled } from '../../utils/instagramDmTest'
import InstagramDmTestCodePanel from './InstagramDmTestCodePanel.vue'
import InstagramDmTestIssueForm from './InstagramDmTestIssueForm.vue'

interface Props {
  visible: boolean
  prizeId: number
  campaignStatus?: number
  hasRunningCampaignOnSameAccount?: boolean
  onRefresh: () => Promise<void> | void
}

interface Emits {
  (e: 'close'): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'InstagramDmTestDialog',
  props: {
    visible: { type: Boolean },
    prizeId: null,
    campaignStatus: null,
    hasRunningCampaignOnSameAccount: { type: Boolean },
    onRefresh: null
  },
  emits: ["close"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'close'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  visible: boolean
  prizeId: number
  campaignStatus?: number
  hasRunningCampaignOnSameAccount?: boolean
  onRefresh: () => Promise<void> | void
};

// @ts-nocheck TODO: 既存の型エラーを解消したら外す


const store = useInstagramInstantwinPretestStore()

const { proxy } = getCurrentInstance() as {
  proxy: {
    $notify: (arg: { title: string; customClass: string; duration: number }) => void
  }
}

const isDisabled = computed(() =>
  isInstagramDmTestDisabled(props.campaignStatus, props.hasRunningCampaignOnSameAccount)
)
const currentRef = computed(() => store.current)
const visibleRef = computed(() => props.visible)
const { remainingMinutes, isExpired } = useInstagramDmTestCodeExpiry(currentRef, visibleRef)
const codePanelState = computed(() => getInstagramDmTestCodePanelState(store.current, store.disabled, isExpired.value))

watch(
  () => props.visible,
  async visible => {
    if (!visible) {
      store.reset()
      return
    }

    try {
      await store.load(props.prizeId, isDisabled.value)
    } catch {
      proxy.$notify({
        title: 'データ取得に失敗しました',
        customClass: 'danger',
        duration: 5000
      })
    }
  },
  { immediate: true }
)

watch(
  () => isDisabled.value,
  value => {
    store.setDisabled(value)
  }
)

function handleClose() {
  TrackingService.sendEvent('click:応募グループ一覧（IGIW）|テストダイアログを閉じる')
  emit('close')
}

async function handleIssue() {
  const actionName = store.current ? '再発行' : '発行'
  TrackingService.sendEvent(`click:応募グループ一覧（IGIW）|テストコード${actionName}`)

  try {
    await store.issue()
    await props.onRefresh()
    proxy.$notify({
      title: 'テストコードを発行しました。',
      customClass: 'success',
      duration: 3000
    })
  } catch {
    proxy.$notify({
      title: store.errorMessage || 'テストコードの発行に失敗しました',
      customClass: 'danger',
      duration: 5000
    })

    if (store.shouldRefreshCampaignState) {
      await props.onRefresh()
    }
  }
}

async function handleCopy(code: string) {
  TrackingService.sendEvent('click:応募グループ一覧（IGIW）|テストコードコピー')

  try {
    await navigator.clipboard.writeText(code)
    proxy.$notify({
      title: 'テストコードをコピーしました',
      customClass: 'success',
      duration: 3000
    })
  } catch {
    proxy.$notify({
      title: 'テストコードのコピーに失敗しました',
      customClass: 'warning',
      duration: 5000
    })
  }
}

return { __sfc: true,props, emit, store, proxy, isDisabled, currentRef, visibleRef, remainingMinutes, isExpired, codePanelState, handleClose, handleIssue, handleCopy, Message, InstagramDmTestCodePanel, InstagramDmTestIssueForm }
}

})